export default __webpack_public_path__ + "static/media/sad-macbook.2af32fc4.gif";